import { CSClient, type CSTypes } from '@tf/api';

export const getClientAreaIrQuery = async (
	revision: string,
	locale: string,
): Promise<CSTypes.GetClientAreaIrResponse> => {
	const res = await CSClient.getInstance().getClientAreaIr({ revision: revision, locale: locale });
	return res.json();
};
